import { AxiosError } from 'axios';

/**
 * Shared retry policy: retry transient failures (network / 5xx / 429) up to 2×,
 * never retry deterministic client errors (401/403/404/422) — DEVELOPMENT_PLAN §17.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false;
  if (error instanceof AxiosError && error.response) {
    const status = error.response.status;
    if (status >= 400 && status < 500 && status !== 429) return false;
  }
  return true;
}

export const queryDefaults = { retry: shouldRetry, staleTime: 15_000, refetchOnWindowFocus: false } as const;
